export default {
  width: '100%',
  height: '100%',
  modestbranding: 1,
  showinfo: 0,
  controls: true,
  rel: 0,
  playing: false
};
